// Copyright (c) 2025 TrustCloud Corporation - All rights reserved.
//
// This software contains valuable confidential and proprietary information of
// TrustCloud Corporation
//
// Unauthorized use, reproduction, transmission, or distribution of this file and its
// contents is a violation of applicable law.

import styled from '@emotion/styled';

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;

  width: 1200px;

  @media (min-width: 1920px) {
    width: 1400px;
  }

  margin-left: auto;
  margin-right: auto;

  text-align: center;

  & .statement-card {
    display: flex;
    flex-direction: column;
    gap: 36px;

    border-radius: 16px;

    & p:nth-child(2) {
      font-weight: 500;
      font-family: Lato;
    }
  }

  & .statement-primary {
    font-weight: 600;
  }
`;
